class Site {
    static toggleReadMore(button) {
        var categoryTextEl = document.querySelector('.inner-collection-description');
        var buttonText = button.querySelector('.read-more-btn-txt');
        var buttonIcon = button.querySelector('.read-more-btn-icon');
        var currentState = button.dataset.currentState;
        switch (currentState) {
        // text hidden - now show full text
        case 'text_hidden':
            categoryTextEl.classList.add('category-text-expanded');
            button.dataset.currentState = 'text_shown';
            buttonText.innerHTML = 'Read Less';
            buttonIcon.classList.add('fa-chevron-up');
            buttonIcon.classList.remove('fa-chevron-down');
            break;
        // text shown = now hide full text
        case 'text_shown':
            categoryTextEl.classList.remove('category-text-expanded');
            button.dataset.currentState = 'text_hidden';
            buttonText.innerHTML = 'Read More';
            buttonIcon.classList.remove('fa-chevron-up');
            buttonIcon.classList.add('fa-chevron-down');
            break;
        }
    }
}